'use strict';

var mafmt = require('mafmt');

var _require = require('./constants'),
    CODE_CIRCUIT = _require.CODE_CIRCUIT,
    CODE_P2P = _require.CODE_P2P,
    CODE_TCP = _require.CODE_TCP,
    CODE_WS = _require.CODE_WS,
    CODE_WSS = _require.CODE_WSS;

module.exports = {
  all: function all(multiaddrs) {
    return multiaddrs.filter(function (ma) {
      if (ma.protoCodes().includes(CODE_CIRCUIT)) {
        return false;
      }

      var testMa = ma.decapsulateCode(CODE_P2P);
      return mafmt.WebSockets.matches(testMa) || mafmt.WebSocketsSecure.matches(testMa);
    });
  },
  dnsWss: function dnsWss(multiaddrs) {
    return multiaddrs.filter(function (ma) {
      if (ma.protoCodes().includes(CODE_CIRCUIT)) {
        return false;
      }

      var testMa = ma.decapsulateCode(CODE_P2P);
      return mafmt.WebSocketsSecure.matches(testMa) && mafmt.DNS.matches(testMa.decapsulateCode(CODE_TCP).decapsulateCode(CODE_WSS));
    });
  },
  dnsWsOrWss: function dnsWsOrWss(multiaddrs) {
    return multiaddrs.filter(function (ma) {
      if (ma.protoCodes().includes(CODE_CIRCUIT)) {
        return false;
      }

      var testMa = ma.decapsulateCode(CODE_P2P); // WS

      if (mafmt.WebSockets.matches(testMa)) {
        return mafmt.DNS.matches(testMa.decapsulateCode(CODE_TCP).decapsulateCode(CODE_WS));
      } // WSS


      return mafmt.WebSocketsSecure.matches(testMa) && mafmt.DNS.matches(testMa.decapsulateCode(CODE_TCP).decapsulateCode(CODE_WSS));
    });
  }
};